import React, {useEffect, useRef, useState} from 'react';
import Section from "../../components/section";
import HelperService from "../../services/helper-service";
import MainLayout from "../../layouts/main";
import {useGlobalNotificationMessage} from "../../context/message";
import PageTitle from "../../components/page-title";
import DataTableActions from "../../components/datatable/data-table-actions";
import DataTableBase from "../../components/datatable/data-table-base";
import {useNavigate} from "react-router-dom";
import {BuildingOwnershipTypes} from "../../utils/constants";
import {useBuildingService} from "../../services/building-service";
import AddEditBuildingModal from "./add-edit-building-modal";


export default function BuildingsList () {
  let buildingService = useBuildingService();
  const {addErrorMessage, removeMessage } = useGlobalNotificationMessage();
  const [rows, setRows] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const addEditModal = useRef();
  const navigate = useNavigate();

  useEffect(()=>{
    buildingService.getList()
      .then((rows)=>{
        setRows(rows);
        setLoaded(true);
      })
      .catch(error => {
        HelperService.handleApiErrors(error, addErrorMessage, "Nepodarilo sa získať dáta.");
      })
  }, []);

  const onAddEditAction = (row=null, e=null)=>{
    addEditModal.current.openModal(row);
  };

  const onAddEditCallbackAction = (item=null)=>{
    setRows(HelperService.addOrReplaceItemInList(rows,item));
  };

  const onDelAction = (item, e=null)=>{
    if (true===confirm('Naozaj odstrániť záznam?')){
      buildingService.delModel(item.id)
        .then(()=>{
          setRows(HelperService.removeItemFromList(rows,item));
        })
        .catch(error => {
          HelperService.handleApiErrors(error, addErrorMessage);
        })
    }
  };

  const columns = [{
    name: 'Názov',
    selector: row => row.title,
    sortable: true,
  },{
    name: 'Typ vlastníctva',
    center: true,
    selector: row => row.ownership_type,
    format: row => <span className={`badge bg-${HelperService.getObjByKey(Object.values(BuildingOwnershipTypes), 'val', row.ownership_type)?.color}`}>{HelperService.getObjByKey(Object.values(BuildingOwnershipTypes), 'val', row.ownership_type)?.title}</span>,
    filterSelector: row => { return HelperService.getObjByKey(Object.values(BuildingOwnershipTypes), 'val', row.ownership_type)?.title },
    sortable: true,
  },{
    cell: row => <DataTableActions row={row} actions={[
      {title: 'Upraviť', icon: <span className="mdi mdi-book-edit-outline"></span>, action: onAddEditAction, className: 'hover-text-primary'},
      {title: 'Zmazať', icon: <span className="mdi mdi-trash-can-outline"></span>, action: onDelAction, className: 'hover-text-danger'},
    ]} />,
    right: true,
    allowOverflow: true,
    button: false,
  }];

  return (
    <>
      <AddEditBuildingModal ref={addEditModal} onSuccess={onAddEditCallbackAction} />

      <Section animation={HelperService.getRandomAnimation()}>
        <div className="container mt-4">

          <PageTitle>Budovy</PageTitle>

          <button className="btn btn-primary mb-2" onClick={(e)=>onAddEditAction(null, e)}><span className="mdi mdi-plus"></span> Pridať</button>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">

                 <DataTableBase
                    progressPending={!loaded}
                    columns={columns}
                    data={rows}
                    // onRowClicked={(row)=>navigate(`${AppRoutes.users.path}/${row.id}`)}
                  />

                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>
    </>
  );
}

BuildingsList.getLayout = function getLayout(page) {
  return (
    <MainLayout>
      {page}
    </MainLayout>
  )
}

BuildingsList.getSEO = function getSEO() {
  return {
    title: "Budovy",
  }
}
